export default "__VITE_ASSET__R8bV4UuD__"